export async function captureSummary(node, { subtitle = '', fileName = 'cimento-ozeti.jpg' } = {}) {
  if (!node) throw new Error('Paylaşılacak alan bulunamadı.');
  const { default: html2canvas } = await import('html2canvas');
  const surface = document.createElement('div');
  surface.className = 'cimento-app executive-summary daily-summary share-export-surface';
  Object.assign(surface.style, { position: 'absolute', left: '-12000px', top: '0', width: '1040px', minHeight: '0', maxWidth: 'none', margin: '0', padding: '24px', background: '#ffffff', color: '#172033', fontFamily: 'Arial, sans-serif', boxSizing: 'border-box', pointerEvents: 'none' });
  if (subtitle) {
    const caption = document.createElement('div');
    caption.className = 'share-export-date';
    caption.textContent = subtitle;
    Object.assign(caption.style, { color: '#526579', fontSize: '14px', fontWeight: '600', textAlign: 'right', marginBottom: '16px' });
    surface.appendChild(caption);
  }
  const clone = node.cloneNode(true);
  clone.querySelectorAll('[data-export-exclude]').forEach(element => element.remove());
  [clone, ...clone.querySelectorAll('[id]')].forEach(element => element.removeAttribute('id'));
  Object.assign(clone.style, { width: '100%', maxWidth: 'none', margin: '0', boxSizing: 'border-box' });
  clone.querySelectorAll('.executive-region-grid, .executive-delivery-grid').forEach(grid => {
    Object.assign(grid.style, { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '12px' });
  });
  clone.querySelectorAll('.executive-mta-list').forEach(grid => { grid.style.gridTemplateColumns = 'repeat(2, minmax(0, 1fr))'; });
  clone.querySelectorAll('.cimento-table-wrap').forEach(wrap => { Object.assign(wrap.style, { overflow: 'visible', maxHeight: 'none' }); });
  clone.querySelectorAll('table').forEach(table => { Object.assign(table.style, { display: 'table', width: '100%', minWidth: '0' }); });
  surface.appendChild(clone);
  document.body.appendChild(surface);
  try {
    const height = Math.ceil(Math.max(surface.scrollHeight, surface.getBoundingClientRect().height, 1));
    // Paint the DOM directly to canvas. SVG foreignObject exports can produce
    // an entirely blank image on mobile browsers without reporting an error.
    const canvas = await html2canvas(surface, {
      backgroundColor: '#ffffff', width: 1040, height,
      scale: Math.min(2, 8000 / height), logging: false,
      windowWidth: 1100, windowHeight: Math.max(height, 800), scrollX: 0, scrollY: 0,
      onclone: (_document, clonedSurface) => {
        Object.assign(clonedSurface.style, { position: 'absolute', left: '0', top: '0', transform: 'none' });
      },
    });
    const dataUrl = canvas.toDataURL('image/jpeg', 0.94);
    const bytes = Uint8Array.from(atob(dataUrl.split(',')[1]), character => character.charCodeAt(0));
    const file = new File([bytes], fileName, { type: 'image/jpeg' });
    return { dataUrl, file };
  } finally { surface.remove(); }
}

export function canShareImage(file) {
  try { return typeof navigator.share === 'function' && typeof navigator.canShare === 'function' && navigator.canShare({ files: [file] }); }
  catch { return false; }
}

export function downloadImage(file) {
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url; link.download = file.name;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
